import {gsap} from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( !window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        $( '.pill-image-cta' ).each( function( key, component ) {
          const vehicle = $( component ).find( '.pill-image-cta__vehicle' );
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 50%',
              scrub: 0.15,
              onRefresh: ( self ) => {
                if ( self.progress > 0 ) {
                  $( vehicle ).addClass( 'js-animated' );
                }
              },
              onEnter: ( {progress, direction, isActive} ) => {
                $( vehicle ).addClass( 'js-animated' );
              },
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'pill-image-cta', COMPONENT );
} )( app );
